import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { api } from "@/lib/api";
import { CURATED_STATUS, fmtMoney } from "@/pages/curated/shared";
import { WindowPicker, StatTiles, DailyBars } from "@/pages/curated/CuratedStatsTab";

export default function CuratedStatsOverview({ onOpen }) {
  const [days, setDays] = useState(30);
  const { data, isLoading } = useQuery({ queryKey: ["curated-stats-overview", days], queryFn: async () => (await api.get("/curated/stats/overview", { params: { days } })).data });
  return (
    <div className="space-y-4" data-testid="curated-stats-overview">
      <div className="flex items-center justify-between"><p className="text-sm text-muted-foreground">Todos los Curated Trips activos · {data?.trips_count ?? "…"} viajes.</p><WindowPicker value={days} onChange={setDays} /></div>
      {isLoading || !data ? <Skeleton className="h-24 w-full" /> : (<>
        <StatTiles s={data} currency="USD" />
        <Card><CardContent className="p-4"><p className="mb-3 text-xs uppercase tracking-wider text-muted-foreground">Visitas por día (verde = holds)</p><DailyBars daily={data.daily} /></CardContent></Card>
        <Card><CardContent className="p-0">
          <Table data-testid="curated-stats-trips">
            <TableHeader><TableRow><TableHead>Viaje</TableHead><TableHead>Estado</TableHead><TableHead>Plazas</TableHead><TableHead>Visitas</TableHead><TableHead>Reserve</TableHead><TableHead>Holds</TableHead><TableHead>Pagadas</TableHead><TableHead>Recaudado</TableHead></TableRow></TableHeader>
            <TableBody>
              {data.trips.map((t) => (
                <TableRow key={t.id} className="cursor-pointer" onClick={() => onOpen(t.id, "stats")} data-testid={`curated-stats-row-${t.id}`}>
                  <TableCell className="font-medium">{t.name}</TableCell>
                  <TableCell><Badge variant={CURATED_STATUS[t.status]?.variant || "secondary"}>{CURATED_STATUS[t.status]?.label || t.status}</Badge></TableCell>
                  <TableCell className="tabular-nums">{t.seats_committed}/{t.capacity}</TableCell>
                  <TableCell className="tabular-nums">{t.views} <span className="text-xs text-muted-foreground">({t.visitors})</span></TableCell>
                  <TableCell className="tabular-nums">{t.reserve_opens}</TableCell>
                  <TableCell className="tabular-nums">{t.holds}</TableCell>
                  <TableCell className="tabular-nums">{t.paid} <span className="text-xs text-muted-foreground">· {t.seats_paid} pl.</span></TableCell>
                  <TableCell className="tabular-nums">{fmtMoney(t.revenue, t.currency)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent></Card>
      </>)}
    </div>
  );
}
